/* ClientTable auto-generated by npm run generator */
import { makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography } from "@material-ui/core"
import { Client, ContentfulApi } from "@qlarity/common"
import { PortalHeader } from "components/atoms/PortalHeader"
import { observer } from "mobx-react"
import React from "react"
import Store from "store/Store"

interface ClientTableProps {
    client: Client
}

const useStyles = makeStyles((theme: Theme) => ({
    clientTableMolecule: {
        border: `1px solid ${theme.palette.secondary.main}`,
        padding: theme.spacing(4),
    },
}))

const ClientTable: React.FC<ClientTableProps> = ({ client }) => {
    const classes = useStyles()
    const headers = ["All Modules", "Status", "Completed On", "Favorite", "# of Trainings", "# of Practices"]
    const getModStatus = (mod: ContentfulApi.QModule) => {
        if (client.progress?.[mod.id]?.practiceCompleted) {
            return "Completed"
        } else if (client.progress?.[mod.id]?.trainingCompleted) {
            return "In Progress"
        } else {
            return "Not Started"
        }
    }

    const getCompletedDate = (mod: ContentfulApi.QModule) => {
        return client.progress?.[mod.id]?.practiceCompleted?.toDate().toLocaleDateString() ?? "N/A"
    }

    const getFavorite = (mod: ContentfulApi.QModule) => {
        return client.favorites?.some((fav) => fav.modId === mod.id) ? "Yes" : "No"
    }

    const getNumOfCompletions = (mod: ContentfulApi.QModule, isTraining?: boolean) => {
        return isTraining ? client.progress?.[mod.id]?.numTrainings : client.progress?.[mod.id]?.numPractices
    }

    return (
        <div className={classes.clientTableMolecule}>
            <PortalHeader>
                <Typography variant="h5">Module Progress: {client.displayName}</Typography>
            </PortalHeader>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((header) => (
                                <TableCell key={header.toString()}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Store.clientStore.modules?.map((mod, i) =>
                            mod ? (
                                <TableRow key={mod.id} hover>
                                    <TableCell>{mod.moduleName}</TableCell>
                                    <TableCell>{getModStatus(mod)}</TableCell>
                                    <TableCell>{getCompletedDate(mod)}</TableCell>
                                    <TableCell>{getFavorite(mod)}</TableCell>
                                    <TableCell>{getNumOfCompletions(mod, true)}</TableCell>
                                    <TableCell>{getNumOfCompletions(mod)}</TableCell>
                                </TableRow>
                            ) : null
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default observer(ClientTable)
